import "@/index.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import Cashflow from "./pages/Cashflow";
import Bancos from "./pages/Bancos";
import KPIs from "./pages/KPIs";
import Bitacora from "./pages/Bitacora";
import GastosFijosEstructura from "./pages/GastosFijosEstructura";
import Nominas from "./pages/Nominas";
import EmpleadoFicha from "./pages/EmpleadoFicha";
import Archivos from "./pages/Archivos";
import ArchivoView from "./pages/ArchivoView";
import GastosFijos from "./pages/GastosFijos";
import Impuestos from "./pages/Impuestos";
import Snapshots from "./pages/Snapshots";
import Duplicados from "./pages/Duplicados";
import Comparador from "./pages/Comparador";
import Usuarios from "./pages/Usuarios";
import Manual from "./pages/Manual";
import { Toaster } from "sonner";

function AppRouter() {
  const location = useLocation();
  // CRITICAL: detect session_id BEFORE other routes to prevent race conditions
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<ProtectedRoute><Layout /></ProtectedRoute>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/cashflow" element={<Cashflow />} />
        <Route path="/gastos-fijos" element={<GastosFijos />} />
        <Route path="/impuestos" element={<Impuestos />} />
        <Route path="/snapshots" element={<Snapshots />} />
        <Route path="/bancos" element={<Bancos />} />
        <Route path="/duplicados" element={<ProtectedRoute ownerOnly><Duplicados /></ProtectedRoute>} />
        <Route path="/comparador" element={<ProtectedRoute ownerOnly><Comparador /></ProtectedRoute>} />
        <Route path="/kpis" element={<ProtectedRoute ownerOnly><KPIs /></ProtectedRoute>} />
        <Route path="/bitacora" element={<ProtectedRoute ownerOnly><Bitacora /></ProtectedRoute>} />
        <Route path="/gastos-fijos-estructura" element={<ProtectedRoute ownerOnly><GastosFijosEstructura /></ProtectedRoute>} />
        <Route path="/nominas" element={<ProtectedRoute ownerOnly><Nominas /></ProtectedRoute>} />
        <Route path="/rrhh/:id" element={<ProtectedRoute ownerOnly><EmpleadoFicha /></ProtectedRoute>} />
        <Route path="/archivos" element={<Archivos />} />
        <Route path="/archivos/:id" element={<ArchivoView />} />
        <Route path="/manual" element={<Manual />} />
        <Route
          path="/usuarios"
          element={
            <ProtectedRoute adminOnly>
              <Usuarios />
            </ProtectedRoute>
          }
        />
      </Route>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster position="top-right" richColors closeButton />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
